import {action, observable, runInAction} from 'mobx';
import {MARKUP_ICONS} from '../constants/markup-icons';
import {primary} from '../themes/colors';
import {isMobile} from '../utils/screenUtility';
import {MarkupIconKind} from "../constants/enums";


class Icon {
    type;
    category;
    key;
    name;
    disableModifying
    @observable panelLoaded;

    data = {};

    constructor(type, category, key, name, disableModifying) {
        this.type = type;
        this.category = category;
        this.key = key;
        this.name = name;
        this.disableModifying = disableModifying;
        this.panelLoaded = false;
    }

    async getPanelSvg() {
        return this.getSvgIcon(MarkupIconKind.Panel);
    }

    async getCanvasSvg() {
        return this.getSvgIcon(MarkupIconKind.Canvas);
    }

    getResolvedPanelIcon() {
        return window.btoa(this.data[MarkupIconKind.Panel]);
    }

    getResolvedActivePanelIcon() {
        if (this.disableModifying) {
            const fixedSvg = this.fixSvg(this.data[MarkupIconKind.Panel]);
            fixedSvg.replace(/currentColor/g, primary);
            return window.btoa(fixedSvg.replace(/currentColor/g, primary));
        }
        this.data[MarkupIconKind.Panel].replace(/currentColor/g, primary);
        return window.btoa(this.data[MarkupIconKind.Panel].replace(/currentColor/g, primary));
    }

    async getCanvasSvgWithColorAndScaleTxt(color = 'currentColor') {
        let svgStr = await this.getCanvasSvg();
        svgStr = svgStr.replace(/<svg width=".*?" height=".*?"/, `<svg width="76" height="76"`);
        if (!this.disableModifying) {
            svgStr = svgStr.replace(/fill="(?!none|white).*?"/g, `fill="${color}"`);
        }
        return svgStr;
    }

    async getCanvasSvgWithColorAndScale(color = 'currentColor') {
        return window.btoa(await this.getCanvasSvgWithColorAndScaleTxt(color));
    }

    async getSvgIcon(kind) {
        if (this.data[kind]) {
            return this.data[kind];
        }
        try {
            let svgRes = await fetch(`/media/markup/${this.type}/${this.category}/${kind}/${this.key}.svg`);
            this.data[kind] = await svgRes.text();
            if (!this.disableModifying) {
                this.data[kind] = this.fixSvg(this.data[kind]);
            }
            return this.data[kind];
        } catch (err) {
            console.log('error loading icon', err);
        } finally {
            if (kind === MarkupIconKind.Panel) {
                runInAction(() => {
                    this.panelLoaded = true;
                })
            }
        }
    }

    fixSvg(svg) {
        return svg.replace(/fill="(?!none|white).*?"/g, 'fill="currentColor"');
    }

}

export class IconStore {
    @observable markupIconsStorage = {};
    // @observable updater = null;
    fitIconsOnScreenAmount = isMobile() ? 5 : 16;


    constructor() {
        this.createIconStorage();
    }

    @action createIconStorage = () => {
        this.markupIconsStorage = MARKUP_ICONS.reduce((res, icon) => {
            if (!res[icon.type]) {
                res[icon.type] = {};
            }
            if (!res[icon.type][icon.category]) {
                res[icon.type][icon.category] = [];
            }
            res[icon.type][icon.category].push(new Icon(icon.type, icon.category, icon.key, icon.name, icon.disableModifying));
            return res;
        }, {});
    }


    getCategoriesByType = (type) => {
        return Object.keys(this.markupIconsStorage[type]);
    }


    getActiveCategory = (type, category) => this.markupIconsStorage[type][category];

    isLoadingFirst = (type, category) => {
        return this.getActiveCategory(type, category).slice(0, this.fitIconsOnScreenAmount).some(icon => !icon.panelLoaded)
    }

    loadIcons = async (type, category, firstLoadDone = () => {
    }) => {
        await Promise.all(this.getActiveCategory(type, category).slice(0, this.fitIconsOnScreenAmount).map(async icon => {
            await icon.getPanelSvg()
        }));
        firstLoadDone();
        this.getActiveCategory(type, category).slice(this.fitIconsOnScreenAmount).map(icon => {
            icon.getPanelSvg();
        });
    }
}

const iconStore = new IconStore();
export default iconStore;
